/*
default: vastaanottokäynti,
phone: hoitopuhelu,
treatmentperiod (type === TYPE_COXA_TREATMENT_PERIOD): hoitojakso,
remote: etävastaanotto,
hospitalWard: hoitojakso,

IMAGING
TOMOGRAPHY: tietokonetomografiatutkimus (TT),
MAGNET: Magneettitutkimus,
ISOTOPERESEARCH: Isotooppitutkimus,
ISOTOPETREATMENT: Isotooppihoito,
RESEARCHVISIT: Tutkimuskäynti,
CAREVISIT: Hoitokäynti,
TRANSILLUMINATIONRESEARCH: Läpivalaisututkimus,
XRAYRESEARCH: Röntgentutkimus,
ULTRASOUNDRESEARCH: Ultraäänitutkimus,
FACEANDTEETHRESEARCH: Kasvo-/hampaistotutkimus,
MAMMOGRAPGHYRESEARCH: Mammografiatutkimus,
BONEDENSITYRESEARCH: Luuntiheysmittaustutkimus

*/

import {TYPE_COXA_TREATMENT_PERIOD} from "../definitions/TimelineItems";
import {isPhoneVisit, isRemoteVisit} from "./TimelineUtils";


const FORMULA_NOTIFICATION_DESCRIPTION = {
    DEFAULT: "vastaanottokäynti",
    PHONE: "hoitopuhelu",
    TREATMENTPERIOD: "hoitojakso",
    REMOTE: "etävastaanotto",
    HOSPITALWARD: "hoitojakso",
    TOMOGRAPHY: "tietokonetomografiatutkimus (TT)",
    MAGNET: "magneettitutkimus",
    ISOTOPERESEARCH: "isotooppitutkimus",
    ISOTOPETREATMENT: "isotooppihoito",
    RESEARCHVISIT: "tutkimuskäynti",
    CAREVISIT: "hoitokäynti",
    TRANSILLUMINATIONRESEARCH: "läpivalaisututkimus",
    XRAYRESEARCH: "röntgentutkimus",
    ULTRASOUNDRESEARCH: "ultraäänitutkimus",
    FACEANDTEETHRESEARCH: "kasvo-/hampaistotutkimus",
    MAMMOGRAPGHYRESEARCH: "mammografiatutkimus",
    BONEDENSITYRESEARCH: "luuntiheysmittaustutkimus"
}

// Max size for base 64 form attachment 65mb (50mb + 30% from base64 encryption)
const FORMULA_FORM_ATTACHMENT_MAX_SIZE = 68157440;

export const getDescriptionTypeFromTimelineEventForAssignedForm = (timelineEvent) => {
    return determineDescriptionType(timelineEvent);
}

const determineDescriptionType = (timelineEvent) => {
    if (!timelineEvent) return;

    if (timelineEvent?.config?.type === 'imaging') {
        return determineImagingFormulaNotificationDescription(timelineEvent?.config?.subtype);
    } else if (timelineEvent?.config?.type === 'hospitalWard') {
        return FORMULA_NOTIFICATION_DESCRIPTION.HOSPITALWARD;
    } else {
        return getDescriptionType(timelineEvent);
    }
}

const determineImagingFormulaNotificationDescription = (subtype) => {
    let type = subtype.toString().split('_').slice(-1).pop();
    if (type) {
        return FORMULA_NOTIFICATION_DESCRIPTION[type];
    }
    return FORMULA_NOTIFICATION_DESCRIPTION.DEFAULT;
}


const getDescriptionType = (timelineEvent) => {
    if (isRemoteVisit(timelineEvent)) {
        return FORMULA_NOTIFICATION_DESCRIPTION.REMOTE;
    } else if (isPhoneVisit(timelineEvent)) {
        return FORMULA_NOTIFICATION_DESCRIPTION.PHONE;
    } else if (timelineEvent.type === TYPE_COXA_TREATMENT_PERIOD) {
        return FORMULA_NOTIFICATION_DESCRIPTION.TREATMENTPERIOD;
    } else {
        return FORMULA_NOTIFICATION_DESCRIPTION.DEFAULT;
    }
}

export const isFormAttachment = (config) => {
    if (config) {
        return config?.meta?.kuvaliite === true;
    }
}

const PAYLOAD_PREFIX = "data:image";

export const isValidFormAttachmentPayload = (data) => {
    if(!data) {
        return false;
    }

    let index = Object.values(data).findIndex(v => {
        return Array.isArray(v) && v[0].substring(0, PAYLOAD_PREFIX.length) === PAYLOAD_PREFIX
    })

    if(index >= 0) {
        let payloadSize = new Blob([data[Object.keys(data)[index]]]).size;
        return payloadSize <= FORMULA_FORM_ATTACHMENT_MAX_SIZE;
    }
    return false;
}
